// PaymentPage.layout_variant ("Page Design"). The column is a plain string;
// the payment app and the native checkout render Classic for any value they
// don't recognise, so a new design is added here and in both renderers. The
// server only accepts these values: keep PAYMENT_PAGE_LAYOUT_VARIANTS in
// apps/server/src/modules/api/payment-page/payment-page.constants.ts in step.
export const LAYOUT_VARIANT_VALUES = ["classic", "v2", "phase4"] as const;

export type LayoutVariant = (typeof LAYOUT_VARIANT_VALUES)[number];

export const LAYOUT_VARIANT_LABELS: Record<LayoutVariant, string> = {
  classic: "Classic (default)",
  v2: "New design",
  phase4: "Phase 4",
};
